import { auth } from './metas'
const Transfers = () => import('@/pages/Transfers')

export default [
  {
    path: '/transfers',
    name: 'Transfers',
    component: Transfers,
    meta: auth
  }
]



// WEBPACK FOOTER //
// ./src/router/transfers.route.js